import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ConfirmationCard from '../../components/Shared/ConfirmationCardMultiActionsCard';
import TitleComponent from '../../components/Shared/TitleMultiActionsCard';
import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

import { formatThousands } from '../../utils/fillDynamicText';
import { copyFor } from '../../copy/copy';

const EmailAction = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            peopleCount={props.peopleCount}
            thankYouText={props.thankYouText}
            titleComponent={
                <TitleComponent
                    localRepresentativeState={props.localRepresentativeState}
                    useLocalRepresentative={props.useLocalRepresentative}
                    titleMultiRep={copyFor('feedback', 'representatives', 'email')}
                    titleSingleRep={copyFor(
                        'feedback',
                        'singleRecipient',
                        'email',
                        undefined,
                        {
                            recipientName: props.repFullName
                        }
                    )}
                    titleNoRep={copyFor(
                        'feedback',
                        'singleRecipient',
                        'email',
                        undefined,
                        {
                            recipientName: props.recipientMask
                        }
                    )}
                    thankYouTitle={props.thankYouTitle}
                />
            }
            {...props}
        />
    </TransitionContainerNoExit>
);

EmailAction.propTypes = {
    peopleCount: PropTypes.string.isRequired,
    thankYouText: PropTypes.string.isRequired,
    thankYouTitle: PropTypes.string,
    repFullName: PropTypes.string.isRequired,
    recipientMask: PropTypes.string,
    localRepresentativeState: PropTypes.number,
    useLocalRepresentative: PropTypes.bool
};

export default connect(
    state => ({
        repFullName: state.localRep.localRepData.representative
            ? 'Rep ' + state.localRep.localRepData.representative[0].fullName
            : '',
        peopleCount:
            state.email.completeEmail !== undefined
                ? formatThousands(state.email.completeEmail.endUsersCount)
                : ''
    }),
    {}
)(EmailAction);
